import clsx from "clsx";
import { RujiraLogo } from "../logos/RujiraLogo";

export const Loader = ({ className }: { className?: string }) => (
  <div className={clsx({ loader: true, [`${className}`]: className })}>
    <svg
      className="loader__blob"
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#CE18EC"
        d="M398,320.5Q332,391,247,396.5Q162,402,118.5,326Q75,250,125,184.5Q175,119,258.5,104.5Q342,90,403,170Q464,250,398,320.5Z">
        <animate
          attributeName="d"
          dur="2800ms"
          repeatCount="indefinite"
          values="M398,320.5Q332,391,247,396.5Q162,402,118.5,326Q75,250,125,184.5Q175,119,258.5,104.5Q342,90,403,170Q464,250,398,320.5Z;
  M431,347Q362,444,268.5,412Q175,380,94.5,315Q14,250,86,170.5Q158,91,265,65Q372,39,436,144.5Q500,250,431,347Z;
  M421.5,355Q372,460,248.5,463Q125,466,78.5,358Q32,250,94,168.5Q156,87,251,85Q346,83,408.5,166.5Q471,250,421.5,355Z;
  M382.5,342Q356,434,260.5,415Q165,396,93.5,323Q22,250,90.5,171.5Q159,93,259,76.5Q359,60,384,155Q409,250,382.5,342Z;
  M392,357Q374,464,250.5,463Q127,462,102.5,356Q78,250,114.5,164Q151,78,243.5,90Q336,102,373,176Q410,250,392,357Z;
  M413,340.5Q354,431,255.5,421.5Q157,412,119,331Q81,250,115.5,163Q150,76,254,69.5Q358,63,415,156.5Q472,250,413,340.5Z;
  M398,320.5Q332,391,247,396.5Q162,402,118.5,326Q75,250,125,184.5Q175,119,258.5,104.5Q342,90,403,170Q464,250,398,320.5Z;"
        />
      </path>
    </svg>
    <svg
      className="loader__blob"
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#8535F4"
        d="M390,323.5Q335,397,244.5,407Q154,417,87.5,333.5Q21,250,83,159Q145,68,235.5,93Q326,118,385.5,184Q445,250,390,323.5Z">
        <animate
          attributeName="d"
          dur="3000ms"
          repeatCount="indefinite"
          values="M390,323.5Q335,397,244.5,407Q154,417,87.5,333.5Q21,250,83,159Q145,68,235.5,93Q326,118,385.5,184Q445,250,390,323.5Z;
  M388.44284,356.71939Q373.40992,463.43878,249.17148,464.61488Q124.93304,465.79098,81.27136,357.89549Q37.60969,250,90.26674,157.44284Q142.92379,64.88568,254.70496,56.66629Q366.48613,48.44691,384.98095,149.22345Q403.47577,250,388.44284,356.71939Z;
  M388.87386,333.816Q346.57737,417.63199,250.12159,417.26268Q153.6658,416.89337,92.342,333.44668Q31.01821,250,87.75683,158.62159Q144.49545,67.24317,258.11248,53.51365Q371.72952,39.78414,401.44993,144.89207Q431.17035,250,388.87386,333.816Z;
  M407.11178,321.2174Q331.96274,392.43479,239.55747,410.67856Q147.15219,428.92233,101.65993,339.46116Q56.16767,250,93.41459,146.54815Q130.66151,43.0963,250.06678,42.94411Q369.47205,42.79192,425.86644,146.39596Q482.26082,250,407.11178,321.2174Z;
  M418,346.5Q361,443,251.5,440Q142,437,100,343.5Q58,250,98,152.5Q138,55,242,69.5Q346,84,410.5,167Q475,250,418,346.5Z;
  M382.06447,321.8585Q333.27831,393.71699,229.42532,429.21934Q125.57233,464.72169,104.62028,357.36085Q83.66823,250,116.99449,163.79402Q150.32075,77.58805,244.05346,87.46776Q337.78617,97.34748,384.3184,173.67374Q430.85064,250,382.06447,321.8585Z;
  M390,323.5Q335,397,244.5,407Q154,417,87.5,333.5Q21,250,83,159Q145,68,235.5,93Q326,118,385.5,184Q445,250,390,323.5Z;"
        />
      </path>
    </svg>
    <svg
      className="loader__blob"
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#8535F4"
        d="M425.65286,345.08093Q360.09352,440.16185,251.07553,438.03057Q142.05755,435.89929,105.0018,342.94965Q67.94605,250,115.4964,175.04136Q163.04676,100.08273,256.04316,89.00719Q349.03956,77.93166,420.12589,163.96583Q491.21221,250,425.65286,345.08093Z">
        <animate
          attributeName="d"
          dur="2900ms"
          repeatCount="indefinite"
          values="M425.65286,345.08093Q360.09352,440.16185,251.07553,438.03057Q142.05755,435.89929,105.0018,342.94965Q67.94605,250,115.4964,175.04136Q163.04676,100.08273,256.04316,89.00719Q349.03956,77.93166,420.12589,163.96583Q491.21221,250,425.65286,345.08093Z;
  M430.21857,346.57286Q362.09714,443.14572,252.57286,439.04857Q143.04857,434.95143,117.58287,342.47571Q92.11716,250,128.08287,175Q164.04857,100,251.80571,97.38858Q339.56285,94.77715,418.95143,172.38858Q498.34,250,430.21857,346.57286Z;
  M410.5,356.5Q373,463,264.5,437.5Q156,412,86,331Q16,250,71.5,143.5Q127,37,227,77Q327,117,387.5,183.5Q448,250,410.5,356.5Z;
  M412.01351,346.40994Q360.89193,442.81988,266.01351,414.79737Q171.13509,386.77485,125.85573,318.38743Q80.57638,250,106.3107,148.04053Q132.04503,46.08105,234.06304,73.46848Q336.08105,100.85591,399.60807,175.42795Q463.13509,250,412.01351,346.40994Z;
  M391.35886,346Q361,442,257.95529,428.45324Q154.91058,414.90648,104.33899,332.45324Q53.76739,250,93.76242,149.50497Q133.75745,49.00994,237.4851,70.28726Q341.21274,91.56458,381.46523,170.78229Q421.71771,250,391.35886,346Z;
  M425.65286,345.08093Q360.09352,440.16185,251.07553,438.03057Q142.05755,435.89929,105.0018,342.94965Q67.94605,250,115.4964,175.04136Q163.04676,100.08273,256.04316,89.00719Q349.03956,77.93166,420.12589,163.96583Q491.21221,250,425.65286,345.08093Z;"
        />
      </path>
    </svg>
    <svg
      className="loader__spinner"
      viewBox="0 0 24 24"
      stroke="#fff"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <circle
          cx="12"
          cy="12"
          r="9.5"
          fill="none"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="0 150"
        />
      </g>
    </svg>
    <RujiraLogo showText={false} className="loader__mark" />
  </div>
);

export const Spinner = ({ className }: { className?: string }) => (
  <div className={clsx({ spinner: true, [`${className}`]: className })}>
    <svg
      className="spinner__spinner"
      viewBox="0 0 24 24"
      stroke="#fff"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <circle
          cx="12"
          cy="12"
          r="9.5"
          fill="none"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="0 150"
        />
      </g>
    </svg>
  </div>
);
